// extracted by mini-css-extract-plugin
export var growableInput = "_8i-0";
export var tagContainer = "_8i-2";
export var textInput = "_8i-1";